import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { DatabaseIcon, RefreshCwIcon, ChevronDownIcon, ExternalLinkIcon, SettingsIcon, DollarSignIcon, FileTextIcon, PieChartIcon, CreditCardIcon, BarChartIcon, UsersIcon, CheckIcon, XIcon, HomeIcon, BuildingIcon, ArrowRightIcon, LinkIcon } from 'lucide-react';
import Button from './common/Button';
// Mock QuickBooks data
const mockQuickBooksData = {
  connected: true,
  lastSync: '2023-07-10 09:45 AM',
  company: 'Real Estate Ventures LLC',
  availableReports: [{
    id: 'pl',
    name: 'Profit & Loss',
    lastGenerated: '2023-07-01'
  }, {
    id: 'bs',
    name: 'Balance Sheet',
    lastGenerated: '2023-07-01'
  }, {
    id: 'ap',
    name: 'Accounts Payable',
    lastGenerated: '2023-07-05'
  }, {
    id: 'ar',
    name: 'Accounts Receivable',
    lastGenerated: '2023-07-05'
  }, {
    id: 'exp',
    name: 'Expense Report',
    lastGenerated: '2023-07-08'
  }, {
    id: 'tax',
    name: 'Tax Summary',
    lastGenerated: '2023-06-30'
  }, {
    id: 'sales',
    name: 'Sales by Customer',
    lastGenerated: '2023-07-05'
  }, {
    id: 'vendors',
    name: 'Vendor Expenses',
    lastGenerated: '2023-07-05'
  }],
  recentTransactions: [{
    id: 't1',
    date: '2023-07-09',
    description: 'Home Depot - Construction Supplies',
    amount: -2456.78,
    category: 'Construction Expenses',
    propertyId: 'p1',
    projectId: 'proj1'
  }, {
    id: 't2',
    date: '2023-07-07',
    description: 'Rental Income - 123 Main St',
    amount: 1800.0,
    category: 'Rental Income',
    propertyId: 'p1'
  }, {
    id: 't3',
    date: '2023-07-05',
    description: 'City Utilities - Water & Sewer',
    amount: -187.45,
    category: 'Utilities',
    propertyId: 'p2'
  }, {
    id: 't4',
    date: '2023-07-03',
    description: 'Property Insurance Premium',
    amount: -650.0,
    category: 'Insurance',
    propertyId: 'p3'
  }, {
    id: 't5',
    date: '2023-07-01',
    description: 'Rental Income - 456 Oak Ave',
    amount: 2200.0,
    category: 'Rental Income',
    propertyId: 'p2'
  }, {
    id: 't6',
    date: '2023-06-30',
    description: 'Contractor Payment - Plumbing Work',
    amount: -1250.0,
    category: 'Repairs & Maintenance',
    propertyId: 'p1',
    projectId: 'proj2'
  }, {
    id: 't7',
    date: '2023-06-28',
    description: 'Property Tax Payment',
    amount: -3200.0,
    category: 'Taxes',
    propertyId: 'p3'
  }, {
    id: 't8',
    date: '2023-06-25',
    description: 'Rental Income - 789 Pine St',
    amount: 1650.0,
    category: 'Rental Income',
    propertyId: 'p3'
  }],
  properties: [{
    id: 'p1',
    address: '123 Main St',
    income: 1800.0,
    expenses: 650.0,
    netIncome: 1150.0,
    qbConnected: true,
    qbLastSync: '2023-07-09 14:30 PM',
    projects: [{
      id: 'proj1',
      name: 'Bathroom Renovation',
      budget: 15000.0,
      spent: 8500.0,
      qbConnected: true
    }, {
      id: 'proj2',
      name: 'Plumbing Repair',
      budget: 2500.0,
      spent: 1250.0,
      qbConnected: true
    }]
  }, {
    id: 'p2',
    address: '456 Oak Ave',
    income: 2200.0,
    expenses: 850.0,
    netIncome: 1350.0,
    qbConnected: true,
    qbLastSync: '2023-07-08 10:15 AM',
    projects: [{
      id: 'proj3',
      name: 'Kitchen Remodel',
      budget: 25000.0,
      spent: 12000.0,
      qbConnected: true
    }, {
      id: 'proj4',
      name: 'Landscaping',
      budget: 5000.0,
      spent: 4200.0,
      qbConnected: false
    }]
  }, {
    id: 'p3',
    address: '789 Pine St',
    income: 1650.0,
    expenses: 725.0,
    netIncome: 925.0,
    qbConnected: false,
    projects: [{
      id: 'proj5',
      name: 'Roof Replacement',
      budget: 18000.0,
      spent: 0.0,
      qbConnected: false
    }]
  }],
  projects: [{
    id: 'proj1',
    propertyId: 'p1',
    name: 'Bathroom Renovation',
    budget: 15000.0,
    spent: 8500.0,
    remaining: 6500.0,
    progress: 45,
    qbConnected: true
  }, {
    id: 'proj2',
    propertyId: 'p1',
    name: 'Plumbing Repair',
    budget: 2500.0,
    spent: 1250.0,
    remaining: 1250.0,
    progress: 60,
    qbConnected: true
  }, {
    id: 'proj3',
    propertyId: 'p2',
    name: 'Kitchen Remodel',
    budget: 25000.0,
    spent: 12000.0,
    remaining: 13000.0,
    progress: 35,
    qbConnected: true
  }, {
    id: 'proj4',
    propertyId: 'p2',
    name: 'Landscaping',
    budget: 5000.0,
    spent: 4200.0,
    remaining: 800.0,
    progress: 85,
    qbConnected: false
  }, {
    id: 'proj5',
    propertyId: 'p3',
    name: 'Roof Replacement',
    budget: 18000.0,
    spent: 0.0,
    remaining: 18000.0,
    progress: 0,
    qbConnected: false
  }],
  financialSummary: {
    income: {
      current: 14500.0,
      previous: 13200.0,
      change: 9.85
    },
    expenses: {
      current: 8750.25,
      previous: 7900.5,
      change: 10.76
    },
    profit: {
      current: 5749.75,
      previous: 5299.5,
      change: 8.5
    },
    cashFlow: {
      current: 4200.0,
      previous: 3800.0,
      change: 10.53
    }
  }
};
const QuickBooksIntegration = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [showConnectModal, setShowConnectModal] = useState(!mockQuickBooksData.connected);
  const [isSyncing, setIsSyncing] = useState(false);
  const [showReportOptions, setShowReportOptions] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const handleSync = () => {
    setIsSyncing(true);
    // Simulate sync
    setTimeout(() => {
      setIsSyncing(false);
      alert('QuickBooks data synchronized successfully!');
    }, 2000);
  };
  const handleConnect = () => {
    // In a real app, this would initiate OAuth flow with QuickBooks
    setShowConnectModal(false);
    // After successful connection
    alert('QuickBooks connected successfully!');
  };
  const handleGenerateReport = reportId => {
    setShowReportOptions(false);
    // In a real app, this would generate the selected report
    alert(`Generating ${mockQuickBooksData.availableReports.find(r => r.id === reportId).name} report...`);
  };
  const handleConnectProperty = propertyId => {
    // In a real app, this would connect the property to QuickBooks
    alert(`Property ${mockQuickBooksData.properties.find(p => p.id === propertyId).address} connected to QuickBooks!`);
  };
  const handleConnectProject = projectId => {
    // In a real app, this would connect the project to QuickBooks
    alert(`Project ${mockQuickBooksData.projects.find(p => p.id === projectId).name} connected to QuickBooks!`);
  };
  const handlePropertySelect = property => {
    setSelectedProperty(property);
    setSelectedProject(null);
    setActiveTab('property-detail');
  };
  const handleProjectSelect = project => {
    setSelectedProject(project);
    setActiveTab('project-detail');
  };
  const handleBackToProperties = () => {
    setSelectedProperty(null);
    setActiveTab('properties');
  };
  const handleBackToProperty = () => {
    setSelectedProject(null);
    setActiveTab('property-detail');
  };
  return <div className="max-w-7xl mx-auto" data-id="element-2592">
      <div className="flex justify-between items-center mb-6" data-id="element-2593">
        <div data-id="element-2594">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-2595">
            QuickBooks Integration
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-2596">
            Manage financial data for your properties and projects
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-2597">
          <Button size="sm" variant="outline" onClick={() => window.open('https://quickbooks.intuit.com', '_blank')} data-id="element-2598">
            <ExternalLinkIcon className="w-4 h-4 mr-2" data-id="element-2599" />
            Open QuickBooks
          </Button>
          {mockQuickBooksData.connected && <Button size="sm" disabled={isSyncing} onClick={handleSync} data-id="element-2600">
              <RefreshCwIcon className={`w-4 h-4 mr-2 ${isSyncing ? 'animate-spin' : ''}`} data-id="element-2601" />
              {isSyncing ? 'Syncing...' : 'Sync Now'}
            </Button>}
        </div>
      </div>
      {/* Connection Status */}
      {mockQuickBooksData.connected && <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 mb-6" data-id="element-2602">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center" data-id="element-2603">
            <div className="flex items-center" data-id="element-2604">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-2605">
                <DatabaseIcon className="w-5 h-5 text-green-600" data-id="element-2606" />
              </div>
              <div data-id="element-2607">
                <h2 className="font-medium text-gray-900" data-id="element-2608">
                  {mockQuickBooksData.company}
                </h2>
                <p className="text-sm text-gray-500" data-id="element-2609">
                  Last synchronized: {mockQuickBooksData.lastSync}
                </p>
              </div>
            </div>
            <div className="flex items-center mt-3 md:mt-0" data-id="element-2610">
              <div className="relative mr-3" data-id="element-2611">
                <Button size="sm" variant="outline" onClick={() => setShowReportOptions(!showReportOptions)} data-id="element-2612">
                  <FileTextIcon className="w-4 h-4 mr-2" data-id="element-2613" />
                  Generate Report
                  <ChevronDownIcon className="w-4 h-4 ml-1" data-id="element-2614" />
                </Button>
                {showReportOptions && <div className="absolute right-0 mt-1 w-56 bg-white rounded-md shadow-lg z-10 border border-gray-200" data-id="element-2615">
                    <ul className="py-1 max-h-64 overflow-y-auto" data-id="element-2616">
                      {mockQuickBooksData.availableReports.map(report => <li key={report.id} data-id="element-2617">
                          <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center justify-between" onClick={() => handleGenerateReport(report.id)} data-id="element-2618">
                            <span data-id="element-2619">{report.name}</span>
                            <span className="text-xs text-gray-500" data-id="element-2620">
                              {report.lastGenerated}
                            </span>
                          </button>
                        </li>)}
                    </ul>
                  </div>}
              </div>
              <Button size="sm" variant="outline" data-id="element-2621">
                <SettingsIcon className="w-4 h-4 mr-2" data-id="element-2622" />
                Settings
              </Button>
            </div>
          </div>
        </div>}
      {/* Breadcrumbs for Property/Project Detail */}
      {(activeTab === 'property-detail' || activeTab === 'project-detail') && <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-2623">
          <button className="hover:text-gray-700" onClick={() => setActiveTab('dashboard')} data-id="element-2624">
            Dashboard
          </button>
          <ArrowRightIcon className="w-3 h-3 mx-2" data-id="element-2625" />
          {activeTab === 'property-detail' ? <span className="font-medium text-gray-700" data-id="element-2626">
              {selectedProperty.address}
            </span> : <>
              <button className="hover:text-gray-700" onClick={handleBackToProperty} data-id="element-2627">
                {mockQuickBooksData.properties.find(p => p.id === selectedProject.propertyId).address}
              </button>
              <ArrowRightIcon className="w-3 h-3 mx-2" data-id="element-2628" />
              <span className="font-medium text-gray-700" data-id="element-2629">
                {selectedProject.name}
              </span>
            </>}
        </div>}
      {/* Tabs Navigation */}
      {activeTab !== 'property-detail' && activeTab !== 'project-detail' && <div className="bg-white border border-gray-200 rounded-lg shadow-sm mb-6" data-id="element-2630">
          <div className="border-b border-gray-200" data-id="element-2631">
            <nav className="flex -mb-px space-x-8 overflow-x-auto p-4" data-id="element-2632">
              <button className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${activeTab === 'dashboard' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('dashboard')} data-id="element-2633">
                Dashboard
              </button>
              <button className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${activeTab === 'properties' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('properties')} data-id="element-2634">
                Properties
              </button>
              <button className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${activeTab === 'projects' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('projects')} data-id="element-2635">
                Projects
              </button>
              <button className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${activeTab === 'transactions' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('transactions')} data-id="element-2636">
                Transactions
              </button>
              <button className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${activeTab === 'reports' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('reports')} data-id="element-2637">
                Reports
              </button>
            </nav>
          </div>
          {/* Dashboard Tab */}
          {activeTab === 'dashboard' && <div className="p-6" data-id="element-2638">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-2639">
                <FinancialCard title="Total Income" amount={mockQuickBooksData.financialSummary.income.current} change={mockQuickBooksData.financialSummary.income.change} icon={<DollarSignIcon className="w-5 h-5 text-green-600" data-id="element-2641" />} color="green" data-id="element-2640" />
                <FinancialCard title="Total Expenses" amount={mockQuickBooksData.financialSummary.expenses.current} change={mockQuickBooksData.financialSummary.expenses.change} icon={<CreditCardIcon className="w-5 h-5 text-red-600" data-id="element-2643" />} color="red" negative data-id="element-2642" />
                <FinancialCard title="Net Profit" amount={mockQuickBooksData.financialSummary.profit.current} change={mockQuickBooksData.financialSummary.profit.change} icon={<BarChartIcon className="w-5 h-5 text-blue-600" data-id="element-2645" />} color="blue" data-id="element-2644" />
                <FinancialCard title="Cash Flow" amount={mockQuickBooksData.financialSummary.cashFlow.current} change={mockQuickBooksData.financialSummary.cashFlow.change} icon={<PieChartIcon className="w-5 h-5 text-purple-600" data-id="element-2647" />} color="purple" data-id="element-2646" />
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" data-id="element-2648">
                <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4" data-id="element-2649">
                  <div className="flex justify-between items-center mb-4" data-id="element-2650">
                    <h3 className="font-medium text-gray-900" data-id="element-2651">
                      Recent Transactions
                    </h3>
                    <button className="text-blue-600 text-sm hover:underline" onClick={() => setActiveTab('transactions')} data-id="element-2652">
                      View all
                    </button>
                  </div>
                  <div className="space-y-3" data-id="element-2653">
                    {mockQuickBooksData.recentTransactions.slice(0, 5).map(transaction => <div key={transaction.id} className="flex justify-between items-center p-2 hover:bg-gray-50 rounded" data-id="element-2654">
                          <div data-id="element-2655">
                            <p className="text-sm font-medium text-gray-800" data-id="element-2656">
                              {transaction.description}
                            </p>
                            <div className="flex items-center" data-id="element-2657">
                              <p className="text-xs text-gray-500 mr-2" data-id="element-2658">
                                {transaction.date}
                              </p>
                              <span className="text-xs px-2 py-0.5 bg-gray-100 text-gray-600 rounded" data-id="element-2659">
                                {transaction.category}
                              </span>
                            </div>
                          </div>
                          <p className={`text-sm font-medium ${transaction.amount >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-2660">
                            {transaction.amount >= 0 ? '+' : ''}$
                            {Math.abs(transaction.amount).toFixed(2)}
                          </p>
                        </div>)}
                  </div>
                </div>
                <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4" data-id="element-2661">
                  <div className="flex justify-between items-center mb-4" data-id="element-2662">
                    <h3 className="font-medium text-gray-900" data-id="element-2663">
                      Property Performance
                    </h3>
                    <button className="text-blue-600 text-sm hover:underline" onClick={() => setActiveTab('properties')} data-id="element-2664">
                      View all
                    </button>
                  </div>
                  <div className="space-y-4" data-id="element-2665">
                    {mockQuickBooksData.properties.slice(0, 3).map(property => <div key={property.id} className="border border-gray-200 rounded-lg p-3" data-id="element-2666">
                          <div className="flex justify-between items-start mb-2" data-id="element-2667">
                            <p className="font-medium text-gray-900" data-id="element-2668">
                              {property.address}
                            </p>
                            {property.qbConnected ? <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full flex items-center" data-id="element-2669">
                                <CheckIcon className="w-3 h-3 mr-1" data-id="element-2670" />
                                QB Connected
                              </span> : <button className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full flex items-center" onClick={() => handleConnectProperty(property.id)} data-id="element-2671">
                                <LinkIcon className="w-3 h-3 mr-1" data-id="element-2672" />
                                Connect to QB
                              </button>}
                          </div>
                          <div className="grid grid-cols-3 gap-2 text-sm" data-id="element-2673">
                            <div data-id="element-2674">
                              <p className="text-gray-500" data-id="element-2675">Income</p>
                              <p className="font-medium text-green-600" data-id="element-2676">
                                ${property.income.toFixed(2)}
                              </p>
                            </div>
                            <div data-id="element-2677">
                              <p className="text-gray-500" data-id="element-2678">Expenses</p>
                              <p className="font-medium text-red-600" data-id="element-2679">
                                ${property.expenses.toFixed(2)}
                              </p>
                            </div>
                            <div data-id="element-2680">
                              <p className="text-gray-500" data-id="element-2681">Net</p>
                              <p className="font-medium text-blue-600" data-id="element-2682">
                                ${property.netIncome.toFixed(2)}
                              </p>
                            </div>
                          </div>
                          <button className="text-blue-600 text-sm mt-2 hover:underline" onClick={() => handlePropertySelect(property)} data-id="element-2683">
                            View details
                          </button>
                        </div>)}
                  </div>
                </div>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 mb-6" data-id="element-2684">
                <div className="flex justify-between items-center mb-4" data-id="element-2685">
                  <h3 className="font-medium text-gray-900" data-id="element-2686">Active Projects</h3>
                  <button className="text-blue-600 text-sm hover:underline" onClick={() => setActiveTab('projects')} data-id="element-2687">
                    View all
                  </button>
                </div>
                <div className="overflow-x-auto" data-id="element-2688">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-2689">
                    <thead className="bg-gray-50" data-id="element-2690">
                      <tr data-id="element-2691">
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2692">
                          Project
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2693">
                          Property
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2694">
                          Budget
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2695">
                          Spent
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2696">
                          Progress
                        </th>
                        <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2697">
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-2698">
                      {mockQuickBooksData.projects.slice(0, 3).map(project => <tr key={project.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => handleProjectSelect(project)} data-id="element-2699">
                            <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2700">
                              {project.name}
                            </td>
                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-2701">
                              {mockQuickBooksData.properties.find(p => p.id === project.propertyId).address}
                            </td>
                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-2702">
                              ${project.budget.toFixed(2)}
                            </td>
                            <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-2703">
                              ${project.spent.toFixed(2)}
                            </td>
                            <td className="px-4 py-3 whitespace-nowrap" data-id="element-2704">
                              <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-2705">
                                <div className="bg-blue-600 h-2.5 rounded-full" style={{
                        width: `${project.progress}%`
                      }} data-id="element-2706"></div>
                              </div>
                              <span className="text-xs text-gray-500" data-id="element-2707">
                                {project.progress}%
                              </span>
                            </td>
                            <td className="px-4 py-3 whitespace-nowrap" data-id="element-2708">
                              {project.qbConnected ? <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full flex items-center w-fit" data-id="element-2709">
                                  <CheckIcon className="w-3 h-3 mr-1" data-id="element-2710" />
                                  QB Connected
                                </span> : <button className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full flex items-center" onClick={e => {
                      e.stopPropagation();
                      handleConnectProject(project.id);
                    }} data-id="element-2711">
                                  <LinkIcon className="w-3 h-3 mr-1" data-id="element-2712" />
                                  Connect to QB
                                </button>}
                            </td>
                          </tr>)}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>}
          {/* Properties Tab */}
          {activeTab === 'properties' && <div className="p-6" data-id="element-2713">
              <div className="flex justify-between items-center mb-6" data-id="element-2714">
                <h3 className="font-medium text-gray-900" data-id="element-2715">
                  Property Financial Performance
                </h3>
                <Link to="/properties" data-id="element-2716">
                  <Button size="sm" data-id="element-2717">
                    <PlusIcon className="w-4 h-4 mr-2" data-id="element-2718" />
                    Add Property
                  </Button>
                </Link>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-2719">
                {mockQuickBooksData.properties.map(property => <div key={property.id} className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden cursor-pointer" onClick={() => handlePropertySelect(property)} data-id="element-2720">
                    <div className="p-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center" data-id="element-2721">
                      <h4 className="font-medium text-gray-900" data-id="element-2722">
                        {property.address}
                      </h4>
                      {property.qbConnected ? <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full flex items-center" data-id="element-2723">
                          <CheckIcon className="w-3 h-3 mr-1" data-id="element-2724" />
                          QB Connected
                        </span> : <button className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full flex items-center" onClick={e => {
                e.stopPropagation();
                handleConnectProperty(property.id);
              }} data-id="element-2725">
                          <LinkIcon className="w-3 h-3 mr-1" data-id="element-2726" />
                          Connect to QB
                        </button>}
                    </div>
                    <div className="p-4" data-id="element-2727">
                      <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-2728">
                        <div data-id="element-2729">
                          <p className="text-sm text-gray-500 mb-1" data-id="element-2730">
                            Monthly Income
                          </p>
                          <p className="text-xl font-semibold text-green-600" data-id="element-2731">
                            ${property.income.toFixed(2)}
                          </p>
                        </div>
                        <div data-id="element-2732">
                          <p className="text-sm text-gray-500 mb-1" data-id="element-2733">
                            Monthly Expenses
                          </p>
                          <p className="text-xl font-semibold text-red-600" data-id="element-2734">
                            ${property.expenses.toFixed(2)}
                          </p>
                        </div>
                      </div>
                      <div className="mb-4" data-id="element-2735">
                        <p className="text-sm text-gray-500 mb-1" data-id="element-2736">Net Income</p>
                        <p className="text-xl font-semibold text-blue-600" data-id="element-2737">
                          ${property.netIncome.toFixed(2)}
                        </p>
                      </div>
                      {property.projects && property.projects.length > 0 && <div className="mb-4" data-id="element-2738">
                          <p className="text-sm text-gray-500 mb-2" data-id="element-2739">
                            Active Projects
                          </p>
                          <div className="space-y-2" data-id="element-2740">
                            {property.projects.map(project => <div key={project.id} className="flex justify-between items-center text-sm" data-id="element-2741">
                                <span data-id="element-2742">{project.name}</span>
                                <span className="font-medium" data-id="element-2743">
                                  ${project.spent.toFixed(2)} / $
                                  {project.budget.toFixed(2)}
                                </span>
                              </div>)}
                          </div>
                        </div>}
                      <div className="flex justify-between pt-4 border-t border-gray-200" data-id="element-2744">
                        <button className="text-blue-600 text-sm hover:underline" data-id="element-2745">
                          View Transactions
                        </button>
                        <button className="text-blue-600 text-sm hover:underline" data-id="element-2746">
                          Generate Report
                        </button>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>}
          {/* Projects Tab */}
          {activeTab === 'projects' && <div className="p-6" data-id="element-2747">
              <div className="flex justify-between items-center mb-6" data-id="element-2748">
                <h3 className="font-medium text-gray-900" data-id="element-2749">
                  Project Financial Tracking
                </h3>
                <Link to="/projects" data-id="element-2750">
                  <Button size="sm" data-id="element-2751">
                    <PlusIcon className="w-4 h-4 mr-2" data-id="element-2752" />
                    Add Project
                  </Button>
                </Link>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-2753">
                <table className="min-w-full divide-y divide-gray-200" data-id="element-2754">
                  <thead className="bg-gray-50" data-id="element-2755">
                    <tr data-id="element-2756">
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2757">
                        Project
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2758">
                        Property
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2759">
                        Budget
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2760">
                        Spent
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2761">
                        Remaining
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2762">
                        Progress
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2763">
                        QuickBooks
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-2764">
                    {mockQuickBooksData.projects.map(project => <tr key={project.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => handleProjectSelect(project)} data-id="element-2765">
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2766">
                          {project.name}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2767">
                          {mockQuickBooksData.properties.find(p => p.id === project.propertyId).address}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-2768">
                          ${project.budget.toFixed(2)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-red-600" data-id="element-2769">
                          ${project.spent.toFixed(2)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-600" data-id="element-2770">
                          ${project.remaining.toFixed(2)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-2771">
                          <div className="flex items-center" data-id="element-2772">
                            <div className="w-full bg-gray-200 rounded-full h-2.5 mr-2 max-w-[100px]" data-id="element-2773">
                              <div className="bg-blue-600 h-2.5 rounded-full" style={{
                        width: `${project.progress}%`
                      }} data-id="element-2774"></div>
                            </div>
                            <span className="text-xs text-gray-500" data-id="element-2775">
                              {project.progress}%
                            </span>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-2776">
                          {project.qbConnected ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-2777">
                              <CheckIcon className="w-3 h-3 mr-1" data-id="element-2778" />
                              Connected
                            </span> : <button className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" onClick={e => {
                    e.stopPropagation();
                    handleConnectProject(project.id);
                  }} data-id="element-2779">
                              <LinkIcon className="w-3 h-3 mr-1" data-id="element-2780" />
                              Connect
                            </button>}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>}
          {/* Transactions Tab */}
          {activeTab === 'transactions' && <div className="p-6" data-id="element-2781">
              <div className="flex justify-between items-center mb-4" data-id="element-2782">
                <h3 className="font-medium text-gray-900" data-id="element-2783">
                  Financial Transactions
                </h3>
                <div className="flex items-center gap-2" data-id="element-2784">
                  <div className="relative" data-id="element-2785">
                    <input type="text" className="block w-full pl-9 pr-3 py-1.5 border border-gray-300 rounded-md text-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500" placeholder="Search transactions..." data-id="element-2786" />
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-2787">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-400" data-id="element-2788">
                        <circle cx="11" cy="11" r="8" data-id="element-2789"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65" data-id="element-2790"></line>
                      </svg>
                    </div>
                  </div>
                  <Button size="sm" data-id="element-2791">
                    <PlusIcon className="w-4 h-4 mr-2" data-id="element-2792" />
                    New Transaction
                  </Button>
                </div>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-2793">
                <table className="min-w-full divide-y divide-gray-200" data-id="element-2794">
                  <thead className="bg-gray-50" data-id="element-2795">
                    <tr data-id="element-2796">
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2797">
                        Date
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2798">
                        Description
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2799">
                        Category
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2800">
                        Property
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2801">
                        Project
                      </th>
                      <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2802">
                        Amount
                      </th>
                      <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2803">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-2804">
                    {mockQuickBooksData.recentTransactions.map(transaction => <tr key={transaction.id} className="hover:bg-gray-50" data-id="element-2805">
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2806">
                            {transaction.date}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2807">
                            {transaction.description}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2808">
                            <span className="px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full bg-gray-100 text-gray-800" data-id="element-2809">
                              {transaction.category}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2810">
                            {transaction.propertyId ? mockQuickBooksData.properties.find(p => p.id === transaction.propertyId)?.address : '-'}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2811">
                            {transaction.projectId ? mockQuickBooksData.projects.find(p => p.id === transaction.projectId)?.name : '-'}
                          </td>
                          <td className={`px-6 py-4 whitespace-nowrap text-sm font-medium text-right ${transaction.amount >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-2812">
                            {transaction.amount >= 0 ? '+' : ''}$
                            {Math.abs(transaction.amount).toFixed(2)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-2813">
                            <button className="text-blue-600 hover:text-blue-900 mr-3" data-id="element-2814">
                              Edit
                            </button>
                            <button className="text-red-600 hover:text-red-900" data-id="element-2815">
                              Delete
                            </button>
                          </td>
                        </tr>)}
                  </tbody>
                </table>
              </div>
            </div>}
          {/* Reports Tab */}
          {activeTab === 'reports' && <div className="p-6" data-id="element-2816">
              <div className="flex justify-between items-center mb-6" data-id="element-2817">
                <h3 className="font-medium text-gray-900" data-id="element-2818">Financial Reports</h3>
                <div className="relative" data-id="element-2819">
                  <Button size="sm" onClick={() => setShowReportOptions(!showReportOptions)} data-id="element-2820">
                    <FileTextIcon className="w-4 h-4 mr-2" data-id="element-2821" />
                    Generate Report
                    <ChevronDownIcon className="w-4 h-4 ml-1" data-id="element-2822" />
                  </Button>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2823">
                {mockQuickBooksData.availableReports.map(report => <div key={report.id} className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 hover:border-blue-300 transition-colors" data-id="element-2824">
                    <div className="flex justify-between items-start" data-id="element-2825">
                      <div data-id="element-2826">
                        <h4 className="font-medium text-gray-900 mb-1" data-id="element-2827">
                          {report.name}
                        </h4>
                        <p className="text-sm text-gray-500" data-id="element-2828">
                          Last generated: {report.lastGenerated}
                        </p>
                      </div>
                      <Button size="sm" variant="outline" onClick={() => handleGenerateReport(report.id)} data-id="element-2829">
                        Generate
                      </Button>
                    </div>
                  </div>)}
              </div>
            </div>}
        </div>}
      {/* Property Detail View */}
      {activeTab === 'property-detail' && selectedProperty && <div className="bg-white border border-gray-200 rounded-lg shadow-sm mb-6" data-id="element-2830">
          <div className="p-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center" data-id="element-2831">
            <div className="flex items-center" data-id="element-2832">
              <HomeIcon className="w-5 h-5 text-gray-500 mr-2" data-id="element-2833" />
              <h3 className="font-medium text-gray-900" data-id="element-2834">
                {selectedProperty.address}
              </h3>
            </div>
            <div className="flex items-center space-x-3" data-id="element-2835">
              {selectedProperty.qbConnected ? <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full flex items-center" data-id="element-2836">
                  <CheckIcon className="w-3 h-3 mr-1" data-id="element-2837" />
                  QuickBooks Connected
                </span> : <button className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full flex items-center" onClick={() => handleConnectProperty(selectedProperty.id)} data-id="element-2838">
                  <LinkIcon className="w-3 h-3 mr-1" data-id="element-2839" />
                  Connect to QuickBooks
                </button>}
              <Button size="sm" variant="outline" onClick={handleBackToProperties} data-id="element-2840">
                Back to Properties
              </Button>
            </div>
          </div>
          <div className="p-6" data-id="element-2841">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-2842">
              <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-2843">
                <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-2844">
                  Monthly Income
                </h4>
                <p className="text-2xl font-semibold text-green-600" data-id="element-2845">
                  ${selectedProperty.income.toFixed(2)}
                </p>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-2846">
                <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-2847">
                  Monthly Expenses
                </h4>
                <p className="text-2xl font-semibold text-red-600" data-id="element-2848">
                  ${selectedProperty.expenses.toFixed(2)}
                </p>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-2849">
                <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-2850">
                  Net Income
                </h4>
                <p className="text-2xl font-semibold text-blue-600" data-id="element-2851">
                  ${selectedProperty.netIncome.toFixed(2)}
                </p>
              </div>
            </div>
            <div className="mb-8" data-id="element-2852">
              <h4 className="font-medium text-gray-900 mb-4" data-id="element-2853">Projects</h4>
              {selectedProperty.projects && selectedProperty.projects.length > 0 ? <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-2854">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-2855">
                    <thead className="bg-gray-50" data-id="element-2856">
                      <tr data-id="element-2857">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2858">
                          Project Name
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2859">
                          Budget
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2860">
                          Spent
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2861">
                          QuickBooks
                        </th>
                        <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2862">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-2863">
                      {selectedProperty.projects.map(project => <tr key={project.id} className="hover:bg-gray-50" data-id="element-2864">
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2865">
                            {project.name}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2866">
                            ${project.budget.toFixed(2)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2867">
                            ${project.spent.toFixed(2)}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-2868">
                            {project.qbConnected ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-2869">
                                <CheckIcon className="w-3 h-3 mr-1" data-id="element-2870" />
                                Connected
                              </span> : <button className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" onClick={() => handleConnectProject(project.id)} data-id="element-2871">
                                <LinkIcon className="w-3 h-3 mr-1" data-id="element-2872" />
                                Connect
                              </button>}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-2873">
                            <button className="text-blue-600 hover:text-blue-900" onClick={() => {
                      const fullProject = mockQuickBooksData.projects.find(p => p.id === project.id);
                      handleProjectSelect(fullProject);
                    }} data-id="element-2874">
                              View Details
                            </button>
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div> : <div className="bg-gray-50 p-8 text-center rounded-lg border border-gray-200" data-id="element-2875">
                  <p className="text-gray-500 mb-4" data-id="element-2876">
                    No projects associated with this property.
                  </p>
                  <Link to="/projects" data-id="element-2877">
                    <Button size="sm" data-id="element-2878">
                      <PlusIcon className="w-4 h-4 mr-2" data-id="element-2879" />
                      Add Project
                    </Button>
                  </Link>
                </div>}
            </div>
            <div className="mb-6" data-id="element-2880">
              <h4 className="font-medium text-gray-900 mb-4" data-id="element-2881">
                Recent Transactions
              </h4>
              {mockQuickBooksData.recentTransactions.filter(t => t.propertyId === selectedProperty.id).length > 0 ? <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-2882">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-2883">
                    <thead className="bg-gray-50" data-id="element-2884">
                      <tr data-id="element-2885">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2886">
                          Date
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2887">
                          Description
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2888">
                          Category
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2889">
                          Project
                        </th>
                        <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2890">
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-2891">
                      {mockQuickBooksData.recentTransactions.filter(t => t.propertyId === selectedProperty.id).map(transaction => <tr key={transaction.id} className="hover:bg-gray-50" data-id="element-2892">
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2893">
                              {transaction.date}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2894">
                              {transaction.description}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-2895">
                              <span className="px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full bg-gray-100 text-gray-800" data-id="element-2896">
                                {transaction.category}
                              </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2897">
                              {transaction.projectId ? mockQuickBooksData.projects.find(p => p.id === transaction.projectId)?.name : '-'}
                            </td>
                            <td className={`px-6 py-4 whitespace-nowrap text-sm font-medium text-right ${transaction.amount >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-2898">
                              {transaction.amount >= 0 ? '+' : ''}$
                              {Math.abs(transaction.amount).toFixed(2)}
                            </td>
                          </tr>)}
                    </tbody>
                  </table>
                </div> : <div className="bg-gray-50 p-8 text-center rounded-lg border border-gray-200" data-id="element-2899">
                  <p className="text-gray-500" data-id="element-2900">
                    No transactions found for this property.
                  </p>
                </div>}
            </div>
          </div>
        </div>}
      {/* Project Detail View */}
      {activeTab === 'project-detail' && selectedProject && <div className="bg-white border border-gray-200 rounded-lg shadow-sm mb-6" data-id="element-2901">
          <div className="p-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center" data-id="element-2902">
            <div className="flex items-center" data-id="element-2903">
              <BuildingIcon className="w-5 h-5 text-gray-500 mr-2" data-id="element-2904" />
              <h3 className="font-medium text-gray-900" data-id="element-2905">
                {selectedProject.name}
              </h3>
              <span className="ml-2 text-sm text-gray-500" data-id="element-2906">
                (
                {mockQuickBooksData.properties.find(p => p.id === selectedProject.propertyId)?.address}
                )
              </span>
            </div>
            <div className="flex items-center space-x-3" data-id="element-2907">
              {selectedProject.qbConnected ? <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full flex items-center" data-id="element-2908">
                  <CheckIcon className="w-3 h-3 mr-1" data-id="element-2909" />
                  QuickBooks Connected
                </span> : <button className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full flex items-center" onClick={() => handleConnectProject(selectedProject.id)} data-id="element-2910">
                  <LinkIcon className="w-3 h-3 mr-1" data-id="element-2911" />
                  Connect to QuickBooks
                </button>}
              <Button size="sm" variant="outline" onClick={handleBackToProperty} data-id="element-2912">
                Back to Property
              </Button>
            </div>
          </div>
          <div className="p-6" data-id="element-2913">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-2914">
              <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-2915">
                <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-2916">
                  Total Budget
                </h4>
                <p className="text-2xl font-semibold text-gray-900" data-id="element-2917">
                  ${selectedProject.budget.toFixed(2)}
                </p>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-2918">
                <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-2919">
                  Spent to Date
                </h4>
                <p className="text-2xl font-semibold text-red-600" data-id="element-2920">
                  ${selectedProject.spent.toFixed(2)}
                </p>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-2921">
                <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-2922">
                  Remaining Budget
                </h4>
                <p className="text-2xl font-semibold text-blue-600" data-id="element-2923">
                  ${selectedProject.remaining.toFixed(2)}
                </p>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-2924">
                <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-2925">
                  Completion
                </h4>
                <p className="text-2xl font-semibold text-gray-900" data-id="element-2926">
                  {selectedProject.progress}%
                </p>
                <div className="w-full bg-gray-200 rounded-full h-2.5 mt-2" data-id="element-2927">
                  <div className="bg-blue-600 h-2.5 rounded-full" style={{
                width: `${selectedProject.progress}%`
              }} data-id="element-2928"></div>
                </div>
              </div>
            </div>
            <div className="mb-6" data-id="element-2929">
              <h4 className="font-medium text-gray-900 mb-4" data-id="element-2930">
                Project Transactions
              </h4>
              {mockQuickBooksData.recentTransactions.filter(t => t.projectId === selectedProject.id).length > 0 ? <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-2931">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-2932">
                    <thead className="bg-gray-50" data-id="element-2933">
                      <tr data-id="element-2934">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2935">
                          Date
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2936">
                          Description
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2937">
                          Category
                        </th>
                        <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2938">
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-2939">
                      {mockQuickBooksData.recentTransactions.filter(t => t.projectId === selectedProject.id).map(transaction => <tr key={transaction.id} className="hover:bg-gray-50" data-id="element-2940">
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2941">
                              {transaction.date}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2942">
                              {transaction.description}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-2943">
                              <span className="px-2 py-1 inline-flex text-xs leading-5 font-medium rounded-full bg-gray-100 text-gray-800" data-id="element-2944">
                                {transaction.category}
                              </span>
                            </td>
                            <td className={`px-6 py-4 whitespace-nowrap text-sm font-medium text-right ${transaction.amount >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-2945">
                              {transaction.amount >= 0 ? '+' : ''}$
                              {Math.abs(transaction.amount).toFixed(2)}
                            </td>
                          </tr>)}
                    </tbody>
                  </table>
                </div> : <div className="bg-gray-50 p-8 text-center rounded-lg border border-gray-200" data-id="element-2946">
                  <p className="text-gray-500 mb-4" data-id="element-2947">
                    No transactions found for this project.
                  </p>
                  <Button size="sm" data-id="element-2948">
                    <PlusIcon className="w-4 h-4 mr-2" data-id="element-2949" />
                    Add Transaction
                  </Button>
                </div>}
            </div>
          </div>
        </div>}
      {/* Connect Modal */}
      {showConnectModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-2950">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md" data-id="element-2951">
            <div className="text-center mb-6" data-id="element-2952">
              <DatabaseIcon className="w-16 h-16 text-green-600 mx-auto mb-4" data-id="element-2953" />
              <h3 className="text-xl font-medium text-gray-900" data-id="element-2954">
                Connect to QuickBooks
              </h3>
              <p className="text-gray-500 mt-2" data-id="element-2955">
                Link your QuickBooks account to access your financial data
                directly within the application.
              </p>
            </div>
            <div className="space-y-4" data-id="element-2956">
              <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-2957">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-2958">
                  Benefits of connecting:
                </h4>
                <ul className="text-sm text-gray-600 space-y-2" data-id="element-2959">
                  <li className="flex items-start" data-id="element-2960">
                    <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-2961" />
                    <span data-id="element-2962">
                      Automatically sync financial data for your properties
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-2963">
                    <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-2964" />
                    <span data-id="element-2965">Track income and expenses for each property</span>
                  </li>
                  <li className="flex items-start" data-id="element-2966">
                    <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-2967" />
                    <span data-id="element-2968">
                      Monitor project budgets and expenses in real-time
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-2969">
                    <CheckIcon className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" data-id="element-2970" />
                    <span data-id="element-2971">
                      Generate financial reports with property and project
                      breakdowns
                    </span>
                  </li>
                </ul>
              </div>
              <p className="text-sm text-gray-500" data-id="element-2972">
                By connecting, you agree to our terms of service and privacy
                policy regarding third-party integrations.
              </p>
            </div>
            <div className="flex justify-end mt-6 space-x-3" data-id="element-2973">
              <Button variant="outline" onClick={() => setShowConnectModal(false)} data-id="element-2974">
                Cancel
              </Button>
              <Button onClick={handleConnect} data-id="element-2975">
                <ExternalLinkIcon className="w-4 h-4 mr-2" data-id="element-2976" />
                Connect to QuickBooks
              </Button>
            </div>
          </div>
        </div>}
    </div>;
};
// Financial Card Component
const FinancialCard = ({
  title,
  amount,
  change,
  icon,
  color,
  negative = false
}) => {
  const getColorClasses = color => {
    switch (color) {
      case 'green':
        return 'bg-green-100 text-green-600';
      case 'red':
        return 'bg-red-100 text-red-600';
      case 'blue':
        return 'bg-blue-100 text-blue-600';
      case 'purple':
        return 'bg-purple-100 text-purple-600';
      case 'yellow':
        return 'bg-yellow-100 text-yellow-600';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  };
  return <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4" data-id="element-2977">
      <div className="flex justify-between items-start mb-3" data-id="element-2978">
        <div className={`p-2 rounded-md ${getColorClasses(color)}`} data-id="element-2979">{icon}</div>
        <div className={`text-xs font-medium ${change >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-2980">
          {change >= 0 ? '+' : ''}
          {change}%
        </div>
      </div>
      <p className="text-sm text-gray-500" data-id="element-2981">{title}</p>
      <p className={`text-xl font-semibold ${negative ? 'text-red-600' : 'text-gray-900'}`} data-id="element-2982">
        ${amount.toFixed(2)}
      </p>
    </div>;
};
// Quick Action Button Component
const QuickActionButton = ({
  label,
  icon,
  color
}) => {
  const getColorClasses = color => {
    switch (color) {
      case 'green':
        return 'bg-green-50 text-green-600 hover:bg-green-100';
      case 'red':
        return 'bg-red-50 text-red-600 hover:bg-red-100';
      case 'blue':
        return 'bg-blue-50 text-blue-600 hover:bg-blue-100';
      case 'purple':
        return 'bg-purple-50 text-purple-600 hover:bg-purple-100';
      case 'yellow':
        return 'bg-yellow-50 text-yellow-600 hover:bg-yellow-100';
      default:
        return 'bg-gray-50 text-gray-600 hover:bg-gray-100';
    }
  };
  return <button className={`p-3 rounded-lg flex flex-col items-center justify-center transition-colors ${getColorClasses(color)}`} data-id="element-2983">
      <div className="mb-2" data-id="element-2984">{icon}</div>
      <span className="text-xs font-medium" data-id="element-2985">{label}</span>
    </button>;
};
export default QuickBooksIntegration;